import Icon from '../../../assets/icons/Icon';
// import { useRemoteConfig } from '../../../remoteConfig';

const NotificationBanner = () => {
    //   const { warningMessage, shouldShowWarning } = useRemoteConfig();
    const shouldShowWarning = false;
    const warningMessage = 'test';

    return shouldShowWarning ? (
        <div className="notification-banner">
            <Icon
                icon="Warning"
                fontSize={35}
                className="notification-banner-icon"
            />
            <span className="notification-banner-span">{warningMessage}</span>
        </div>
    ) : null;
};
export default NotificationBanner;
